import { TipoCaixaModel } from './../../model/caixa/tipocaixa.model';
import { ResponsePageable } from './../../model/cliente/pageable/responsePageable.model';
import { Observable } from 'rxjs/Observable';
import { environment } from './../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class TipoCaixaService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  getTipoCaixas(page: number, size: number): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-tipos-caixa?page=${page}&size=${size}`, this.httpOptions);
  }

  getTipoCaixasUsuario(): Observable<Array<TipoCaixaModel>> {
    return this.httpClient.get<Array<TipoCaixaModel>>(this.apiURL + '/view/listar-tipos-caixa-usuario', this.httpOptions);
  }

  postTipoCaixa(tipoCaixa: TipoCaixaModel): Observable<TipoCaixaModel> {
    return this.httpClient.post<TipoCaixaModel>(this.apiURL + '/new/adicionar-tipo-caixa', tipoCaixa, this.httpOptions);
  }

  putTipoCaixa(tipoCaixa: TipoCaixaModel): Observable<TipoCaixaModel> {
    return this.httpClient.put<TipoCaixaModel>(this.apiURL + '/edit/editar-tipo-caixa', tipoCaixa, this.httpOptions);
  }

  deleteTipoCaixa(id: any) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.delete(this.apiURL + '/delete/apagar-tipo-caixa/' + id, { headers, responseType: 'text' })
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/caixa/tipo-caixa.service.ts